const config = {
	events: {
		"e-4": {
			id: "e-4",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-5",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|8990ba9b-3907-a4be-c090-887b3448126a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|8990ba9b-3907-a4be-c090-887b3448126a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620151110303,
		},
		"e-5": {
			id: "e-5",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_OUT_OF_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-2",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-30",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|8990ba9b-3907-a4be-c090-887b3448126a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|8990ba9b-3907-a4be-c090-887b3448126a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620151110304,
		},
		"e-9": {
			id: "e-9",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-5",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-10",
				},
			},
			mediaQueries: ["main", "medium"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|129f32a8-d53b-eb0c-027d-f64cbad04119",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|129f32a8-d53b-eb0c-027d-f64cbad04119",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620168953787,
		},
		"e-15": {
			id: "e-15",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-9",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-16",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60931fca8a1d1dd588f6b71e|23f9396a-d9c7-abb3-aed7-f630ca8c781f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60931fca8a1d1dd588f6b71e|23f9396a-d9c7-abb3-aed7-f630ca8c781f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620312126794,
		},
		"e-16": {
			id: "e-16",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_OUT_OF_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-10",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-15",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60931fca8a1d1dd588f6b71e|23f9396a-d9c7-abb3-aed7-f630ca8c781f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60931fca8a1d1dd588f6b71e|23f9396a-d9c7-abb3-aed7-f630ca8c781f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620312126796,
		},
		"e-17": {
			id: "e-17",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-11",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-18",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60931fca8a1d1dd588f6b71e|d1201d4b-1cfc-2c86-5bb4-55de24ebc189",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60931fca8a1d1dd588f6b71e|d1201d4b-1cfc-2c86-5bb4-55de24ebc189",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620338526161,
		},
		"e-18": {
			id: "e-18",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-12",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-17",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60931fca8a1d1dd588f6b71e|d1201d4b-1cfc-2c86-5bb4-55de24ebc189",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60931fca8a1d1dd588f6b71e|d1201d4b-1cfc-2c86-5bb4-55de24ebc189",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620338526162,
		},
		"e-19": {
			id: "e-19",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-13",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-20",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443cd",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443cd",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620419475793,
		},
		"e-20": {
			id: "e-20",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-14",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-19",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443cd",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443cd",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620419475794,
		},
		"e-21": {
			id: "e-21",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-13",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-22",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|07876316-899e-7f28-23eb-1f5c1cb50f5d",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|07876316-899e-7f28-23eb-1f5c1cb50f5d",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620419634414,
		},
		"e-22": {
			id: "e-22",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-14",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-21",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|07876316-899e-7f28-23eb-1f5c1cb50f5d",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|07876316-899e-7f28-23eb-1f5c1cb50f5d",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620419634415,
		},
		"e-25": {
			id: "e-25",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-15",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-26",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "c494af52-4c97-dfa6-9980-d126a0bd617a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "c494af52-4c97-dfa6-9980-d126a0bd617a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620679166206,
		},
		"e-26": {
			id: "e-26",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-16",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-25",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "c494af52-4c97-dfa6-9980-d126a0bd617a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "c494af52-4c97-dfa6-9980-d126a0bd617a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620679166207,
		},
		"e-27": {
			id: "e-27",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-17",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-28",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff70",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff70",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1569983041157,
		},
		"e-28": {
			id: "e-28",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-18",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-27",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff70",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff70",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1569983041160,
		},
		"e-29": {
			id: "e-29",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-19",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-30",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff70",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff70",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1569983151307,
		},
		"e-31": {
			id: "e-31",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-20",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-32",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443c6",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443c6",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620745136656,
		},
		"e-33": {
			id: "e-33",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-19",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-34",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|dd595e56-7330-122d-2406-968c70b86563",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|dd595e56-7330-122d-2406-968c70b86563",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620765552453,
		},
		"e-35": {
			id: "e-35",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-13",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-36",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443c6",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443c6",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620767420656,
		},
		"e-36": {
			id: "e-36",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-14",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-35",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443c6",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443c6",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620767420658,
		},
		"e-41": {
			id: "e-41",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-19",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-42",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|d8e8808c-e153-03f4-9275-73a5306ae723",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|d8e8808c-e153-03f4-9275-73a5306ae723",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620767564404,
		},
		"e-43": {
			id: "e-43",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-21",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-44",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443cd",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|2c4b6300-b2b0-4dc2-831d-4264c43443cd",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620767598696,
		},
		"e-45": {
			id: "e-45",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-23",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-46",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|d7096048-01db-a607-4694-b32574c1620a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|d7096048-01db-a607-4694-b32574c1620a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620768250651,
		},
		"e-47": {
			id: "e-47",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-17",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-48",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|d7096048-01db-a607-4694-b32574c1620a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|d7096048-01db-a607-4694-b32574c1620a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620768250651,
		},
		"e-48": {
			id: "e-48",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-18",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-47",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|d7096048-01db-a607-4694-b32574c1620a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|d7096048-01db-a607-4694-b32574c1620a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620768250651,
		},
		"e-53": {
			id: "e-53",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-24",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-54",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|199d857b-f295-8a95-f1c7-025a998f74ff",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|199d857b-f295-8a95-f1c7-025a998f74ff",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620770727407,
		},
		"e-55": {
			id: "e-55",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-22",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-56",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|07876316-899e-7f28-23eb-1f5c1cb50f5d",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|07876316-899e-7f28-23eb-1f5c1cb50f5d",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620770797350,
		},
		"e-57": {
			id: "e-57",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-17",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-58",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|1bc872ad-c745-0844-224f-ccaa04353d77",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|1bc872ad-c745-0844-224f-ccaa04353d77",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620771951649,
		},
		"e-58": {
			id: "e-58",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-18",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-57",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|1bc872ad-c745-0844-224f-ccaa04353d77",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|1bc872ad-c745-0844-224f-ccaa04353d77",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620771951649,
		},
		"e-59": {
			id: "e-59",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-24",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-60",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|1bc872ad-c745-0844-224f-ccaa04353d77",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|1bc872ad-c745-0844-224f-ccaa04353d77",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620771951649,
		},
		"e-61": {
			id: "e-61",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-25",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-62",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|c8a4ec82-0ca7-b3f9-6945-570b8e887283",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|c8a4ec82-0ca7-b3f9-6945-570b8e887283",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620857299341,
		},
		"e-62": {
			id: "e-62",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-26",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-61",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|c8a4ec82-0ca7-b3f9-6945-570b8e887283",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|c8a4ec82-0ca7-b3f9-6945-570b8e887283",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620857299344,
		},
		"e-63": {
			id: "e-63",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-25",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-64",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|da24277c-f705-c414-9e10-a9c7150c371a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|da24277c-f705-c414-9e10-a9c7150c371a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620857376996,
		},
		"e-64": {
			id: "e-64",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-26",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-63",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|da24277c-f705-c414-9e10-a9c7150c371a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|da24277c-f705-c414-9e10-a9c7150c371a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620857376999,
		},
		"e-65": {
			id: "e-65",
			name: "",
			animationType: "custom",
			eventTypeId: "PAGE_START",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-66",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7",
				appliesTo: "PAGE",
				styleBlockIds: [],
			},
			targets: [
				{id: "604aa3b3fc4380e3fd436ab7", appliesTo: "PAGE", styleBlockIds: []},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1620920228937,
		},
		"e-69": {
			id: "e-69",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-29",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-70",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|13d129e4-5202-90dc-0bac-1231a81a9086",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|13d129e4-5202-90dc-0bac-1231a81a9086",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621263774819,
		},
		"e-70": {
			id: "e-70",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_OUT_OF_VIEW",
			action: {
				id: "",
				actionTypeId: "PLUGIN_LOTTIE_EFFECT",
				instant: false,
				config: {actionListId: "pluginLottieReverse", autoStopEventId: "e-69"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|13d129e4-5202-90dc-0bac-1231a81a9086",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|13d129e4-5202-90dc-0bac-1231a81a9086",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: true,
				scrollOffsetValue: 30,
				scrollOffsetUnit: "%",
				delay: 600,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621263774823,
		},
		"e-71": {
			id: "e-71",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-30",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-72",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|acc09c9b-1f44-87b3-09fd-6e1d105eef4b",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|acc09c9b-1f44-87b3-09fd-6e1d105eef4b",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621266052071,
		},
		"e-72": {
			id: "e-72",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_OUT_OF_VIEW",
			action: {
				id: "",
				actionTypeId: "PLUGIN_LOTTIE_EFFECT",
				instant: false,
				config: {actionListId: "pluginLottieReverse", autoStopEventId: "e-71"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|acc09c9b-1f44-87b3-09fd-6e1d105eef4b",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|acc09c9b-1f44-87b3-09fd-6e1d105eef4b",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: true,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621266052074,
		},
		"e-73": {
			id: "e-73",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-30",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-74",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621266421227,
		},
		"e-74": {
			id: "e-74",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_OUT_OF_VIEW",
			action: {
				id: "",
				actionTypeId: "PLUGIN_LOTTIE_EFFECT",
				instant: false,
				config: {actionListId: "pluginLottieReverse", autoStopEventId: "e-73"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: true,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621266421230,
		},
		"e-75": {
			id: "e-75",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-31",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-76",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621268930035,
		},
		"e-76": {
			id: "e-76",
			name: "",
			animationType: "custom",
			eventTypeId: "SCROLL_OUT_OF_VIEW",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-31",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-75",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 0,
				scrollOffsetUnit: "%",
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1621268930037,
		},
		"e-77": {
			id: "e-77",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-78"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|87bbb787-f419-8ec2-ebf5-965da71c2016",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|87bbb787-f419-8ec2-ebf5-965da71c2016",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 600,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1621270506730,
		},
		"e-79": {
			id: "e-79",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-80"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|503e4d80-bf93-3656-3200-2ec2b9721729",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|503e4d80-bf93-3656-3200-2ec2b9721729",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 600,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1621270609204,
		},
		"e-81": {
			id: "e-81",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GROW_EFFECT",
				instant: false,
				config: {actionListId: "growIn", autoStopEventId: "e-82"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60957160c908ca5171157430|c9e02ca5-ddad-d41d-2143-c3d7095415cb",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60957160c908ca5171157430|c9e02ca5-ddad-d41d-2143-c3d7095415cb",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 600,
				direction: null,
				effectIn: true,
			},
			createdOn: 1621270715543,
		},
		"e-83": {
			id: "e-83",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInLeft", autoStopEventId: "e-84"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60931fca8a1d1dd588f6b71e|b2c52c9c-7b3f-1537-93e8-dc203a23b7cf",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60931fca8a1d1dd588f6b71e|b2c52c9c-7b3f-1537-93e8-dc203a23b7cf",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: "LEFT",
				effectIn: true,
			},
			createdOn: 1621369575261,
		},
		"e-85": {
			id: "e-85",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-15",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-86",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc438093ee436aba|c6b93ead-87f1-4e7c-e1e5-cf73c7f4598f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc438093ee436aba|c6b93ead-87f1-4e7c-e1e5-cf73c7f4598f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1623188745969,
		},
		"e-86": {
			id: "e-86",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-16",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-85",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc438093ee436aba|c6b93ead-87f1-4e7c-e1e5-cf73c7f4598f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc438093ee436aba|c6b93ead-87f1-4e7c-e1e5-cf73c7f4598f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1623188745969,
		},
		"e-87": {
			id: "e-87",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-11",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-88",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc438093ee436aba|6f6855f2-0e3f-e3e2-13dc-6c2ee974215a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc438093ee436aba|6f6855f2-0e3f-e3e2-13dc-6c2ee974215a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1623189234130,
		},
		"e-88": {
			id: "e-88",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-12",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-87",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "604aa3b3fc438093ee436aba|6f6855f2-0e3f-e3e2-13dc-6c2ee974215a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "604aa3b3fc438093ee436aba|6f6855f2-0e3f-e3e2-13dc-6c2ee974215a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1623189234130,
		},
		"e-90": {
			id: "e-90",
			name: "",
			animationType: "custom",
			eventTypeId: "PAGE_FINISH",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-32",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-89",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c105b3e5aa83fbf36bd3c3",
				appliesTo: "PAGE",
				styleBlockIds: [],
			},
			targets: [
				{id: "60c105b3e5aa83fbf36bd3c3", appliesTo: "PAGE", styleBlockIds: []},
			],
			config: {
				loop: true,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1623428305950,
		},
		"e-91": {
			id: "e-91",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-92"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c105b3e5aa83fbf36bd3c3|7de5acd8-3af8-c250-50f4-c127d3fbcd1f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c105b3e5aa83fbf36bd3c3|7de5acd8-3af8-c250-50f4-c127d3fbcd1f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 500,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1623450614366,
		},
		"e-95": {
			id: "e-95",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-96"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c105b3e5aa83fbf36bd3c3|14b23769-eb97-f0da-c224-bc0d71cf92da",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c105b3e5aa83fbf36bd3c3|14b23769-eb97-f0da-c224-bc0d71cf92da",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 500,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1623452610429,
		},
		"e-97": {
			id: "e-97",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-98"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c105b3e5aa83fbf36bd3c3|d0bd5af8-bb17-99fd-9848-ee44bf16395e",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c105b3e5aa83fbf36bd3c3|d0bd5af8-bb17-99fd-9848-ee44bf16395e",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 500,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1623452611711,
		},
		"e-99": {
			id: "e-99",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-100"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c105b3e5aa83fbf36bd3c3|e6320864-b129-8fb6-c50f-66d7c9c85fe0",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c105b3e5aa83fbf36bd3c3|e6320864-b129-8fb6-c50f-66d7c9c85fe0",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 500,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1623452660297,
		},
		"e-113": {
			id: "e-113",
			name: "",
			animationType: "preset",
			eventTypeId: "PAGE_START",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-114",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60cc1988488ce451d3392fd5",
				appliesTo: "PAGE",
				styleBlockIds: [],
			},
			targets: [
				{id: "60cc1988488ce451d3392fd5", appliesTo: "PAGE", styleBlockIds: []},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1623988617199,
		},
		"e-115": {
			id: "e-115",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInBottom", autoStopEventId: "e-116"},
			},
			mediaQueries: ["main", "medium"],
			target: {
				id: "60cc1988488ce451d3392fd5|246dae92-43e7-1449-fe3e-bb03a105a9af",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60cc1988488ce451d3392fd5|246dae92-43e7-1449-fe3e-bb03a105a9af",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: "BOTTOM",
				effectIn: true,
			},
			createdOn: 1624147035369,
		},
		"e-117": {
			id: "e-117",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInBottom", autoStopEventId: "e-118"},
			},
			mediaQueries: ["main", "medium"],
			target: {
				id: "60cc1988488ce451d3392fd5|2ca5ebbf-d6e6-400c-24db-e1d32a2b7b3c",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60cc1988488ce451d3392fd5|2ca5ebbf-d6e6-400c-24db-e1d32a2b7b3c",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 150,
				direction: "BOTTOM",
				effectIn: true,
			},
			createdOn: 1624147044397,
		},
		"e-119": {
			id: "e-119",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInBottom", autoStopEventId: "e-120"},
			},
			mediaQueries: ["main", "medium"],
			target: {
				id: "60cc1988488ce451d3392fd5|53f0374d-2607-929d-bc65-7954bd9ff15e",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60cc1988488ce451d3392fd5|53f0374d-2607-929d-bc65-7954bd9ff15e",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 300,
				direction: "BOTTOM",
				effectIn: true,
			},
			createdOn: 1624147054921,
		},
		"e-121": {
			id: "e-121",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-122"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60cc1988488ce451d3392fd5|6e632ffb-4192-b4b0-2f45-8250b08294bc",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60cc1988488ce451d3392fd5|6e632ffb-4192-b4b0-2f45-8250b08294bc",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 100,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1624252284620,
		},
		"e-123": {
			id: "e-123",
			name: "",
			animationType: "preset",
			eventTypeId: "PAGE_START",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-124",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5",
				appliesTo: "PAGE",
				styleBlockIds: [],
			},
			targets: [
				{id: "60d0277a3fb64c1b57306bc5", appliesTo: "PAGE", styleBlockIds: []},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624254330564,
		},
		"e-133": {
			id: "e-133",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "GROW_EFFECT",
				instant: false,
				config: {actionListId: "growIn", autoStopEventId: "e-134"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60cc1988488ce451d3392fd5|e50385da-3a81-e7d8-e29a-a39eb7bd34ad",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60cc1988488ce451d3392fd5|e50385da-3a81-e7d8-e29a-a39eb7bd34ad",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 20,
				scrollOffsetUnit: "%",
				delay: 0,
				direction: null,
				effectIn: true,
			},
			createdOn: 1624255579886,
		},
		"e-143": {
			id: "e-143",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-33",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-144",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|2f9667bf-47e9-9e2f-c9cb-689bfa2ae84f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|2f9667bf-47e9-9e2f-c9cb-689bfa2ae84f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624266844473,
		},
		"e-144": {
			id: "e-144",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_SECOND_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-34",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-143",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|2f9667bf-47e9-9e2f-c9cb-689bfa2ae84f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|2f9667bf-47e9-9e2f-c9cb-689bfa2ae84f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624266844475,
		},
		"e-145": {
			id: "e-145",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-33",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-146",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|80d7fba8-a471-856f-4d9a-d9d6ae350d6c",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|80d7fba8-a471-856f-4d9a-d9d6ae350d6c",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624267729887,
		},
		"e-146": {
			id: "e-146",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_SECOND_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-34",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-145",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|80d7fba8-a471-856f-4d9a-d9d6ae350d6c",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|80d7fba8-a471-856f-4d9a-d9d6ae350d6c",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624267729887,
		},
		"e-147": {
			id: "e-147",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-33",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-148",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|d3366747-fa9e-8943-38da-ed04d40cb2e1",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|d3366747-fa9e-8943-38da-ed04d40cb2e1",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624267731167,
		},
		"e-148": {
			id: "e-148",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_SECOND_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-34",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-147",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|d3366747-fa9e-8943-38da-ed04d40cb2e1",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|d3366747-fa9e-8943-38da-ed04d40cb2e1",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624267731167,
		},
		"e-149": {
			id: "e-149",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-33",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-150",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|ed9e40dc-24f3-96cd-2950-980f11bf19b3",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|ed9e40dc-24f3-96cd-2950-980f11bf19b3",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624267732984,
		},
		"e-150": {
			id: "e-150",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_SECOND_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-34",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-149",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d0277a3fb64c1b57306bc5|ed9e40dc-24f3-96cd-2950-980f11bf19b3",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d0277a3fb64c1b57306bc5|ed9e40dc-24f3-96cd-2950-980f11bf19b3",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624267732984,
		},
		"e-151": {
			id: "e-151",
			name: "",
			animationType: "preset",
			eventTypeId: "PAGE_START",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-152",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c",
				appliesTo: "PAGE",
				styleBlockIds: [],
			},
			targets: [
				{id: "60d068e29253b740bed4637c", appliesTo: "PAGE", styleBlockIds: []},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624271074974,
		},
		"e-153": {
			id: "e-153",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-35",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-154",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|a8757fcd-aabd-23da-6b14-f9873f84df3f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|a8757fcd-aabd-23da-6b14-f9873f84df3f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275164115,
		},
		"e-154": {
			id: "e-154",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-36",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-153",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|a8757fcd-aabd-23da-6b14-f9873f84df3f",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|a8757fcd-aabd-23da-6b14-f9873f84df3f",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275164118,
		},
		"e-155": {
			id: "e-155",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-35",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-156",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|c09ea36e-1dc9-a3c7-e825-efc27fd0d271",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|c09ea36e-1dc9-a3c7-e825-efc27fd0d271",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275247868,
		},
		"e-156": {
			id: "e-156",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-36",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-155",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|c09ea36e-1dc9-a3c7-e825-efc27fd0d271",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|c09ea36e-1dc9-a3c7-e825-efc27fd0d271",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275247871,
		},
		"e-157": {
			id: "e-157",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-35",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-158",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|c305d56a-183c-81f1-5b17-cb226e9f8a3a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|c305d56a-183c-81f1-5b17-cb226e9f8a3a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275260657,
		},
		"e-158": {
			id: "e-158",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-36",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-157",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|c305d56a-183c-81f1-5b17-cb226e9f8a3a",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|c305d56a-183c-81f1-5b17-cb226e9f8a3a",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275260660,
		},
		"e-159": {
			id: "e-159",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OVER",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-35",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-160",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|3be4a8d0-c1d6-bdc3-292f-7de00d4998a6",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|3be4a8d0-c1d6-bdc3-292f-7de00d4998a6",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275271359,
		},
		"e-160": {
			id: "e-160",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_OUT",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-36",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-159",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d068e29253b740bed4637c|3be4a8d0-c1d6-bdc3-292f-7de00d4998a6",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d068e29253b740bed4637c|3be4a8d0-c1d6-bdc3-292f-7de00d4998a6",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624275271363,
		},
		"e-161": {
			id: "e-161",
			name: "",
			animationType: "preset",
			eventTypeId: "PAGE_START",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-162",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d07ca4416cdd857c22c3b6",
				appliesTo: "PAGE",
				styleBlockIds: [],
			},
			targets: [
				{id: "60d07ca4416cdd857c22c3b6", appliesTo: "PAGE", styleBlockIds: []},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624276133156,
		},
		"e-163": {
			id: "e-163",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-37",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-164",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60ca1cfca606d126e76b065f|f8fcf827-f296-8b8b-cd43-4834a3d0bcac",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60ca1cfca606d126e76b065f|f8fcf827-f296-8b8b-cd43-4834a3d0bcac",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624434729684,
		},
		"e-165": {
			id: "e-165",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-38",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-166",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60ca1cfca606d126e76b065f|13d6dc98-ffb7-09e3-33d3-9fd8040277df",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60ca1cfca606d126e76b065f|13d6dc98-ffb7-09e3-33d3-9fd8040277df",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624434881269,
		},
		"e-167": {
			id: "e-167",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-38",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-168",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60ca1cfca606d126e76b065f|894ec15e-15d9-3704-293c-fdc3b5781d21",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60ca1cfca606d126e76b065f|894ec15e-15d9-3704-293c-fdc3b5781d21",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624434981808,
		},
		"e-169": {
			id: "e-169",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-38",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-170",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c904ce8e738a327b754e97|8d87dff7-6c7b-6966-4b0a-7d4bd392fd3c",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c904ce8e738a327b754e97|8d87dff7-6c7b-6966-4b0a-7d4bd392fd3c",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624435004384,
		},
		"e-171": {
			id: "e-171",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-38",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-172",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c904ce8e738a327b754e97|8d87dff7-6c7b-6966-4b0a-7d4bd392fd40",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c904ce8e738a327b754e97|8d87dff7-6c7b-6966-4b0a-7d4bd392fd40",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624435004384,
		},
		"e-173": {
			id: "e-173",
			name: "",
			animationType: "custom",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-37",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-174",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c904ce8e738a327b754e97|f8fcf827-f296-8b8b-cd43-4834a3d0bcac",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c904ce8e738a327b754e97|f8fcf827-f296-8b8b-cd43-4834a3d0bcac",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624435029035,
		},
		"e-177": {
			id: "e-177",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-38",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-178",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d2eb545cdff9a50b7709f8|8d87dff7-6c7b-6966-4b0a-7d4bd392fd3c",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d2eb545cdff9a50b7709f8|8d87dff7-6c7b-6966-4b0a-7d4bd392fd3c",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624435541000,
		},
		"e-179": {
			id: "e-179",
			name: "",
			animationType: "preset",
			eventTypeId: "MOUSE_CLICK",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-38",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-180",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d2eb545cdff9a50b7709f8|8d87dff7-6c7b-6966-4b0a-7d4bd392fd40",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d2eb545cdff9a50b7709f8|8d87dff7-6c7b-6966-4b0a-7d4bd392fd40",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1624435541000,
		},
		"e-181": {
			id: "e-181",
			name: "",
			animationType: "preset",
			eventTypeId: "SCROLL_INTO_VIEW",
			action: {
				id: "",
				actionTypeId: "SLIDE_EFFECT",
				instant: false,
				config: {actionListId: "slideInRight", autoStopEventId: "e-182"},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60c105b3e5aa83fbf36bd3c3|3674799d-86a6-e413-0d0a-5f3155671ede",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60c105b3e5aa83fbf36bd3c3|3674799d-86a6-e413-0d0a-5f3155671ede",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: 10,
				scrollOffsetUnit: "%",
				delay: 500,
				direction: "RIGHT",
				effectIn: true,
			},
			createdOn: 1625876591289,
		},
		"e-183": {
			id: "e-183",
			name: "",
			animationType: "custom",
			eventTypeId: "DROPDOWN_OPEN",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-39",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-184",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "b0c67572-dcc3-5065-4f38-5fc1094dab97",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "b0c67572-dcc3-5065-4f38-5fc1094dab97",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1626044082236,
		},
		"e-184": {
			id: "e-184",
			name: "",
			animationType: "custom",
			eventTypeId: "DROPDOWN_CLOSE",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-40",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-183",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "b0c67572-dcc3-5065-4f38-5fc1094dab97",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "b0c67572-dcc3-5065-4f38-5fc1094dab97",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1626044082242,
		},
		"e-185": {
			id: "e-185",
			name: "",
			animationType: "preset",
			eventTypeId: "DROPDOWN_OPEN",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-39",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-186",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d07ca4416cdd857c22c3b6|866daeb4-f822-2fa3-7554-dad03624abd1",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d07ca4416cdd857c22c3b6|866daeb4-f822-2fa3-7554-dad03624abd1",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1626044151768,
		},
		"e-186": {
			id: "e-186",
			name: "",
			animationType: "preset",
			eventTypeId: "DROPDOWN_CLOSE",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-40",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-185",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "60d07ca4416cdd857c22c3b6|866daeb4-f822-2fa3-7554-dad03624abd1",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "60d07ca4416cdd857c22c3b6|866daeb4-f822-2fa3-7554-dad03624abd1",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1626044151768,
		},
		"e-187": {
			id: "e-187",
			name: "",
			animationType: "custom",
			eventTypeId: "DROPDOWN_OPEN",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-39",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-188",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "866daeb4-f822-2fa3-7554-dad03624abd1",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "866daeb4-f822-2fa3-7554-dad03624abd1",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1626289545259,
		},
		"e-188": {
			id: "e-188",
			name: "",
			animationType: "custom",
			eventTypeId: "DROPDOWN_CLOSE",
			action: {
				id: "",
				actionTypeId: "GENERAL_START_ACTION",
				config: {
					delay: 0,
					easing: "",
					duration: 0,
					actionListId: "a-40",
					affectedElements: {},
					playInReverse: false,
					autoStopEventId: "e-187",
				},
			},
			mediaQueries: ["main", "medium", "small", "tiny"],
			target: {
				id: "866daeb4-f822-2fa3-7554-dad03624abd1",
				appliesTo: "ELEMENT",
				styleBlockIds: [],
			},
			targets: [
				{
					id: "866daeb4-f822-2fa3-7554-dad03624abd1",
					appliesTo: "ELEMENT",
					styleBlockIds: [],
				},
			],
			config: {
				loop: false,
				playInReverse: false,
				scrollOffsetValue: null,
				scrollOffsetUnit: null,
				delay: null,
				direction: null,
				effectIn: null,
			},
			createdOn: 1626289545265,
		},
	},
	actionLists: {
		a: {
			id: "a",
			title: "alex appears",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-n",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".alex",
									selectorGuids: ["d1c0962e-1218-7e84-3ffb-c2648d1c508a"],
								},
								xValue: 80,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-n-2",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 1000,
								easing: "outBounce",
								duration: 500,
								target: {
									selector: ".alex",
									selectorGuids: ["d1c0962e-1218-7e84-3ffb-c2648d1c508a"],
								},
								xValue: -1,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1607123498906,
		},
		"a-2": {
			id: "a-2",
			title: "alex hides",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-2-n",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".alex",
									selectorGuids: ["d1c0962e-1218-7e84-3ffb-c2648d1c508a"],
								},
								xValue: -1,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-2-n-2",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 800,
								easing: "outBounce",
								duration: 800,
								target: {
									selector: ".alex",
									selectorGuids: ["d1c0962e-1218-7e84-3ffb-c2648d1c508a"],
								},
								xValue: 124,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1607127547691,
		},
		"a-5": {
			id: "a-5",
			title: "plane moves in",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-5-n",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".airplane-01",
									selectorGuids: ["ddf9e4f5-5df7-a308-42df-e632f6a3754f"],
								},
								xValue: -900,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-5-n-2",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "swingFromTo",
								duration: 2000,
								target: {
									selector: ".airplane-01",
									selectorGuids: ["ddf9e4f5-5df7-a308-42df-e632f6a3754f"],
								},
								xValue: 0,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1620167997883,
		},
		"a-9": {
			id: "a-9",
			title: "Alex online laptop - appears",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-9-n",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "outBounce",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".alex.online",
									selectorGuids: [
										"d1c0962e-1218-7e84-3ffb-c2648d1c508a",
										"2b636fe8-3799-d3ab-bb9b-e60c1189db2a",
									],
								},
								xValue: 111,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-9-n-2",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 1000,
								easing: "outBounce",
								duration: 1000,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".alex.online",
									selectorGuids: [
										"d1c0962e-1218-7e84-3ffb-c2648d1c508a",
										"2b636fe8-3799-d3ab-bb9b-e60c1189db2a",
									],
								},
								xValue: 0,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1607123498906,
		},
		"a-10": {
			id: "a-10",
			title: "Alex online laptop - hides",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-10-n",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".alex.online",
									selectorGuids: [
										"d1c0962e-1218-7e84-3ffb-c2648d1c508a",
										"2b636fe8-3799-d3ab-bb9b-e60c1189db2a",
									],
								},
								xValue: 0,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-10-n-2",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".alex.online",
									selectorGuids: [
										"d1c0962e-1218-7e84-3ffb-c2648d1c508a",
										"2b636fe8-3799-d3ab-bb9b-e60c1189db2a",
									],
								},
								xValue: 208,
								xUnit: "px",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1607127547691,
		},
		"a-11": {
			id: "a-11",
			title: "scale button",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-11-n-2",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "outBounce",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".play-demo-img",
									selectorGuids: ["c29449e2-aed6-6a44-062a-b66a3d56a582"],
								},
								xValue: 1.1,
								yValue: 1.1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620338531809,
		},
		"a-12": {
			id: "a-12",
			title: "scale down button",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-12-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".play-demo-img",
									selectorGuids: ["c29449e2-aed6-6a44-062a-b66a3d56a582"],
								},
								xValue: 1,
								yValue: 1,
								zValue: 1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620338651744,
		},
		"a-13": {
			id: "a-13",
			title: "scale card",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-13-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".subscription-card",
									selectorGuids: ["9665c897-4d53-77df-bd39-18ccc69368f0"],
								},
								xValue: 1,
								yValue: 1,
								locked: true,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-13-n-2",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 400,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".subscription-card",
									selectorGuids: ["9665c897-4d53-77df-bd39-18ccc69368f0"],
								},
								xValue: 1.1,
								yValue: 1.1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1620419481454,
		},
		"a-14": {
			id: "a-14",
			title: "scale down card",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-14-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 400,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".subscription-card",
									selectorGuids: ["9665c897-4d53-77df-bd39-18ccc69368f0"],
								},
								xValue: 1,
								yValue: 1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620419568745,
		},
		"a-15": {
			id: "a-15",
			title: "scale play button",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-15-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".play-img",
									selectorGuids: ["ae8ade1f-3939-50d4-d692-2f6f0e8e63c9"],
								},
								xValue: 1,
								yValue: 1,
								locked: true,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-15-n-2",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 300,
								target: {
									selector: ".play-img",
									selectorGuids: ["ae8ade1f-3939-50d4-d692-2f6f0e8e63c9"],
								},
								xValue: 1.1,
								yValue: 1.1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1620679204044,
		},
		"a-16": {
			id: "a-16",
			title: "scale down play btn",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-16-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "",
								duration: 300,
								target: {
									useEventTarget: true,
									id: "c494af52-4c97-dfa6-9980-d126a0bd617a",
								},
								xValue: 1,
								yValue: 1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620679248961,
		},
		"a-17": {
			id: "a-17",
			title: "close hover",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-17-n",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "inQuart",
								duration: 1000,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".close-image",
									selectorGuids: ["1785fe77-25c3-81d5-2972-6aba0d141b62"],
								},
								zValue: 720,
								xUnit: "DEG",
								yUnit: "DEG",
								zUnit: "DEG",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1569983045594,
		},
		"a-18": {
			id: "a-18",
			title: "close hover out",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-18-n",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "easeIn",
								duration: 500,
								target: {
									id:
										"60957160c908ca5171157430|14f4f635-7144-d77c-0504-f43cce7fff71",
								},
								zValue: 0,
								xUnit: "DEG",
								yUnit: "DEG",
								zUnit: "DEG",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1569983450216,
		},
		"a-19": {
			id: "a-19",
			title: "close bundle modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-19-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									selector: ".modal-wrapper.bundle",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd6158",
										"b9c34117-ce21-0ee9-21fa-b136a130f138",
									],
								},
								value: "none",
							},
						},
						{
							id: "a-19-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".modal-wrap",
									selectorGuids: ["38781439-5be9-c915-c63d-186b3cbd615a"],
								},
								value: 0.5,
								unit: "",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-19-n-3",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".modal-wrap",
									selectorGuids: ["38781439-5be9-c915-c63d-186b3cbd615a"],
								},
								value: 0,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1569983154443,
		},
		"a-20": {
			id: "a-20",
			title: "Open bundle modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-20-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									useEventTarget: "SIBLINGS",
									selector: ".modal-wrapper.bundle",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd6158",
										"b9c34117-ce21-0ee9-21fa-b136a130f138",
									],
								},
								value: "flex",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-20-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "ease",
								duration: 500,
								target: {
									selector: ".modal-wrap.bundle",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd615a",
										"afb82541-7797-b4a1-9c9a-13f71110e232",
									],
								},
								value: 1,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620745152295,
		},
		"a-21": {
			id: "a-21",
			title: "Open yearly modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-21-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									useEventTarget: "SIBLINGS",
									selector: ".modal-wrapper.yearly",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd6158",
										"b2218c94-f61f-84dd-5477-abf92a2796b6",
									],
								},
								value: "flex",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-21-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "ease",
								duration: 500,
								target: {
									selector: ".modal-wrap.yearly",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd615a",
										"2e2195d6-fd4e-f5cf-9cc6-6aedd5ad9f70",
									],
								},
								value: 1,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620745152295,
		},
		"a-23": {
			id: "a-23",
			title: "close yearly modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-23-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									selector: ".modal-wrapper.yearly",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd6158",
										"b2218c94-f61f-84dd-5477-abf92a2796b6",
									],
								},
								value: "none",
							},
						},
						{
							id: "a-23-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".modal-wrap",
									selectorGuids: ["38781439-5be9-c915-c63d-186b3cbd615a"],
								},
								value: 0.5,
								unit: "",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-23-n-3",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".modal-wrap",
									selectorGuids: ["38781439-5be9-c915-c63d-186b3cbd615a"],
								},
								value: 0,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1569983154443,
		},
		"a-24": {
			id: "a-24",
			title: "close monthly modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-24-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									selector: ".modal-wrapper.monthly",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd6158",
										"70d9a6dc-8ab1-9606-1259-9465d4470bbc",
									],
								},
								value: "none",
							},
						},
						{
							id: "a-24-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".modal-wrap",
									selectorGuids: ["38781439-5be9-c915-c63d-186b3cbd615a"],
								},
								value: 0.5,
								unit: "",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-24-n-3",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".modal-wrap",
									selectorGuids: ["38781439-5be9-c915-c63d-186b3cbd615a"],
								},
								value: 0,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1569983154443,
		},
		"a-22": {
			id: "a-22",
			title: "Open monthly modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-22-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									useEventTarget: "SIBLINGS",
									selector: ".modal-wrapper.monthly",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd6158",
										"70d9a6dc-8ab1-9606-1259-9465d4470bbc",
									],
								},
								value: "flex",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-22-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "ease",
								duration: 500,
								target: {
									selector: ".modal-wrap.monthly",
									selectorGuids: [
										"38781439-5be9-c915-c63d-186b3cbd615a",
										"cea13fc2-3f0c-ff17-62b9-68cccb308659",
									],
								},
								value: 1,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620745152295,
		},
		"a-25": {
			id: "a-25",
			title: "scale up logo",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-25-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "",
								duration: 300,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".brand-logo-wrapper",
									selectorGuids: ["354a6205-ffc3-bdc9-e3a1-40cda5184188"],
								},
								xValue: 1,
								yValue: 1,
								locked: true,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-25-n-2",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 300,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".brand-logo-wrapper",
									selectorGuids: ["354a6205-ffc3-bdc9-e3a1-40cda5184188"],
								},
								xValue: 1.1,
								yValue: 1.1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620857320114,
		},
		"a-26": {
			id: "a-26",
			title: "scale down logo",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-26-n",
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 500,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".brand-logo-wrapper",
									selectorGuids: ["354a6205-ffc3-bdc9-e3a1-40cda5184188"],
								},
								xValue: 1,
								yValue: 1,
								locked: true,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1620857391871,
		},
		"a-29": {
			id: "a-29",
			title: "Nellie",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-29-n",
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".nellie-demo",
									selectorGuids: ["ba7b0e28-be6c-c0bf-ff3f-381efd6d6210"],
								},
								value: 1,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-29-n-3",
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 3000,
								target: {
									selector: ".nellie-demo",
									selectorGuids: ["ba7b0e28-be6c-c0bf-ff3f-381efd6d6210"],
								},
								value: 99.9,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1621264272087,
		},
		"a-30": {
			id: "a-30",
			title: "Grogg n Alex animation",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-30-n",
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									useEventTarget: true,
									id:
										"604aa3b3fc4380e3fd436ab7|acc09c9b-1f44-87b3-09fd-6e1d105eef4b",
								},
								value: 1,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-30-n-2",
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 3000,
								target: {
									useEventTarget: true,
									id:
										"604aa3b3fc4380e3fd436ab7|acc09c9b-1f44-87b3-09fd-6e1d105eef4b",
								},
								value: 99.9,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1621266080203,
		},
		"a-31": {
			id: "a-31",
			title: "FIona waves",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-31-n-6",
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 8000,
								target: {
									useEventTarget: true,
									id:
										"604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
								},
								value: 0.9,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-31-n-7",
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 3000,
								target: {
									useEventTarget: true,
									id:
										"604aa3b3fc4380e3fd436ab7|85976195-f4db-5c78-d920-1647e76f8916",
								},
								value: 99.9,
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1621266579932,
		},
		"a-32": {
			id: "a-32",
			title: "bounce",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-32-n",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".down-arrow-bounce",
									selectorGuids: ["eb226233-75af-063c-d98f-39f623b98c30"],
								},
								yValue: 0,
								xUnit: "PX",
								yUnit: "px",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-32-n-2",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "easeInOut",
								duration: 1000,
								target: {
									selector: ".down-arrow-bounce",
									selectorGuids: ["eb226233-75af-063c-d98f-39f623b98c30"],
								},
								yValue: -10,
								xUnit: "PX",
								yUnit: "px",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-32-n-3",
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "easeInOut",
								duration: 1000,
								target: {
									selector: ".down-arrow-bounce",
									selectorGuids: ["eb226233-75af-063c-d98f-39f623b98c30"],
								},
								yValue: 0,
								xUnit: "PX",
								yUnit: "px",
								zUnit: "PX",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1623428312635,
		},
		"a-33": {
			id: "a-33",
			title: "Open expand panel",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-33-n",
							actionTypeId: "STYLE_SIZE",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									useEventTarget: "SIBLINGS",
									selector: ".panel-expand-body",
									selectorGuids: ["91c40a8b-b0b4-48d1-ad6e-c8f7901edb54"],
								},
								widthValue: 100,
								heightValue: 0,
								widthUnit: "%",
								heightUnit: "px",
								locked: false,
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-33-n-2",
							actionTypeId: "STYLE_SIZE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 400,
								target: {
									useEventTarget: "SIBLINGS",
									selector: ".panel-expand-body",
									selectorGuids: ["91c40a8b-b0b4-48d1-ad6e-c8f7901edb54"],
								},
								widthValue: 100,
								widthUnit: "%",
								heightUnit: "AUTO",
								locked: false,
							},
						},
						{
							id: "a-33-n-3",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 400,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".panel-expand-toggle-icon",
									selectorGuids: ["b1949d37-f0e4-4e17-0b15-4af2d133ece7"],
								},
								xValue: -180,
								xUnit: "deg",
								yUnit: "DEG",
								zUnit: "DEG",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1624265959295,
		},
		"a-34": {
			id: "a-34",
			title: "Close expand panel",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-34-n-2",
							actionTypeId: "STYLE_SIZE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 400,
								target: {
									useEventTarget: "SIBLINGS",
									selector: ".panel-expand-body",
									selectorGuids: ["91c40a8b-b0b4-48d1-ad6e-c8f7901edb54"],
								},
								widthValue: 100,
								heightValue: 0,
								widthUnit: "%",
								heightUnit: "px",
								locked: false,
							},
						},
						{
							id: "a-34-n-3",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 400,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".panel-expand-toggle-icon",
									selectorGuids: ["b1949d37-f0e4-4e17-0b15-4af2d133ece7"],
								},
								xValue: 0,
								xUnit: "deg",
								yUnit: "DEG",
								zUnit: "DEG",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1624265959295,
		},
		"a-35": {
			id: "a-35",
			title: "Sequence Guide hover",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-35-n",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 200,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".guide-thumbnail-img",
									selectorGuids: ["5c05ce36-5ec7-78b6-c3b6-8ae064f3c666"],
								},
								zValue: -9,
								xUnit: "DEG",
								yUnit: "DEG",
								zUnit: "deg",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1624275166514,
		},
		"a-36": {
			id: "a-36",
			title: "Sequence Guide hover off",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-36-n",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "ease",
								duration: 200,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".guide-thumbnail-img",
									selectorGuids: ["5c05ce36-5ec7-78b6-c3b6-8ae064f3c666"],
								},
								zValue: 0,
								xUnit: "DEG",
								yUnit: "DEG",
								zUnit: "deg",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1624275166514,
		},
		"a-37": {
			id: "a-37",
			title: "Open cart modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-37-n",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									selector: ".cart-modal-wrapper",
									selectorGuids: ["49e790a3-19fb-df4e-a27d-173c19f19bc9"],
								},
								value: "none",
							},
						},
						{
							id: "a-37-n-2",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "",
								duration: 500,
								target: {
									selector: ".cart-modal-wrapper",
									selectorGuids: ["49e790a3-19fb-df4e-a27d-173c19f19bc9"],
								},
								value: 0,
								unit: "",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-37-n-3",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									selector: ".cart-modal-wrapper",
									selectorGuids: ["49e790a3-19fb-df4e-a27d-173c19f19bc9"],
								},
								value: "flex",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-37-n-4",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "ease",
								duration: 200,
								target: {
									selector: ".cart-modal-wrapper",
									selectorGuids: ["49e790a3-19fb-df4e-a27d-173c19f19bc9"],
								},
								value: 1,
								unit: "",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: true,
			createdOn: 1624434731646,
		},
		"a-38": {
			id: "a-38",
			title: "Close cart modal",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-38-n",
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "ease",
								duration: 200,
								target: {
									selector: ".cart-modal-wrapper",
									selectorGuids: ["49e790a3-19fb-df4e-a27d-173c19f19bc9"],
								},
								value: 0,
								unit: "",
							},
						},
					],
				},
				{
					actionItems: [
						{
							id: "a-38-n-2",
							actionTypeId: "GENERAL_DISPLAY",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									selector: ".cart-modal-wrapper",
									selectorGuids: ["49e790a3-19fb-df4e-a27d-173c19f19bc9"],
								},
								value: "none",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1624434883515,
		},
		"a-39": {
			id: "a-39",
			title: "Nav dropdown open",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-39-n",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".nav-dropdown-toggle-icon",
									selectorGuids: ["bdebbf1e-b9de-b9f2-a855-8cea981d49d8"],
								},
								xValue: 180,
								xUnit: "deg",
								yUnit: "DEG",
								zUnit: "DEG",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1626044084943,
		},
		"a-40": {
			id: "a-40",
			title: "Nav dropdown close",
			actionItemGroups: [
				{
					actionItems: [
						{
							id: "a-40-n",
							actionTypeId: "TRANSFORM_ROTATE",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									useEventTarget: "CHILDREN",
									selector: ".nav-dropdown-toggle-icon",
									selectorGuids: ["bdebbf1e-b9de-b9f2-a855-8cea981d49d8"],
								},
								xValue: 0,
								xUnit: "deg",
								yUnit: "DEG",
								zUnit: "DEG",
							},
						},
					],
				},
			],
			useFirstGroupAsInitialState: false,
			createdOn: 1626044084943,
		},
		pluginLottieReverse: {
			id: "pluginLottieReverse",
			actionItemGroups: [
				{
					actionItems: [
						{
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 100,
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "PLUGIN_LOTTIE",
							config: {
								delay: 0,
								easing: "",
								duration: "auto",
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 0,
							},
						},
					],
				},
			],
		},
		slideInRight: {
			id: "slideInRight",
			useFirstGroupAsInitialState: true,
			actionItemGroups: [
				{
					actionItems: [
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 0,
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 100,
								yValue: 0,
								xUnit: "PX",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 1,
							},
						},
						{
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 0,
								yValue: 0,
								xUnit: "PX",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
		},
		growIn: {
			id: "growIn",
			useFirstGroupAsInitialState: true,
			actionItemGroups: [
				{
					actionItems: [
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 0,
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 0.7500000000000001,
								yValue: 0.7500000000000001,
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "TRANSFORM_SCALE",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 1,
								yValue: 1,
							},
						},
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 1,
							},
						},
					],
				},
			],
		},
		slideInLeft: {
			id: "slideInLeft",
			useFirstGroupAsInitialState: true,
			actionItemGroups: [
				{
					actionItems: [
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 0,
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: -100,
								yValue: 0,
								xUnit: "PX",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 1,
							},
						},
						{
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 0,
								yValue: 0,
								xUnit: "PX",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
			],
		},
		slideInBottom: {
			id: "slideInBottom",
			useFirstGroupAsInitialState: true,
			actionItemGroups: [
				{
					actionItems: [
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 0,
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								duration: 0,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 0,
								yValue: 100,
								xUnit: "PX",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
					],
				},
				{
					actionItems: [
						{
							actionTypeId: "TRANSFORM_MOVE",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								xValue: 0,
								yValue: 0,
								xUnit: "PX",
								yUnit: "PX",
								zUnit: "PX",
							},
						},
						{
							actionTypeId: "STYLE_OPACITY",
							config: {
								delay: 0,
								easing: "outQuart",
								duration: 1000,
								target: {
									id: "N/A",
									appliesTo: "TRIGGER_ELEMENT",
									useEventTarget: true,
								},
								value: 1,
							},
						},
					],
				},
			],
		},
	},
	site: {
		mediaQueries: [
			{key: "main", min: 992, max: 10000},
			{key: "medium", min: 768, max: 991},
			{key: "small", min: 480, max: 767},
			{key: "tiny", min: 0, max: 479},
		],
	},
};

module.exports = config;
